// Fills in .markupeditor-tier-price spans with the live Member tier price,
// read from the <meta id="markupeditor-tier-price"> tag default.hbs renders
// via Ghost's {{#get "tiers"}} helper -- keeps page copy from drifting out
// of sync with the actual tier price without needing a client-side API call.
(function () {
    function formatPrice(cents, currency) {
        var amount = cents / 100;
        var whole = amount % 1 === 0;
        var symbol = (currency || 'usd').toLowerCase() === 'usd' ? '$' : (currency || '').toUpperCase() + ' ';
        return symbol + (whole ? amount.toFixed(0) : amount.toFixed(2)) + '/year';
    }

    function init() {
        var meta = document.getElementById('markupeditor-tier-price');
        var targets = document.querySelectorAll('.markupeditor-tier-price');
        if (!meta || !targets.length) return;

        var cents = parseInt(meta.getAttribute('data-yearly-price'), 10);
        if (!cents) return;

        var text = formatPrice(cents, meta.getAttribute('data-currency'));
        targets.forEach(function (el) {
            el.textContent = text;
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
